import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  activationState: false,
};
const PageNotFoundReducer = createSlice({
  name: "PageNotFound",
  initialState: initialState,
  reducers: {
    updateActivationState(state, action) {
      state.activationState = action.payload;
    },
  },
});
export const PageNotFoundReducerAction = PageNotFoundReducer.actions;
export default PageNotFoundReducer.reducer;
